import { useParams } from "react-router";

import { useFetchQuoteQuery } from "../services/api/quotesApi/quotes";

// ID override when getting this quote outside of the quote page
export function useQuote(idOveride?: number | string) {
  const { organisationId, quoteId } = useParams();

  const quoteIdRes = idOveride || quoteId;
  const result = useFetchQuoteQuery({
    organisationId,
    quoteId: quoteIdRes?.toString(),
  }, {
    skip: !organisationId || !quoteIdRes,
    pollingInterval: 1000 * 10,
    skipPollingIfUnfocused: true,
  });

  return {
    ...result,
    quote: result.data?.quote,
  };
}
